var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table-footer" }, [
    _c("span"),
    _c("div", { staticClass: "paginator" }, [
      _c("span", {
        staticClass: "glicon-back-large",
        class: { disabled: _vm.isFirstPage },
        on: {
          click: function($event) {
            return _vm.previous()
          }
        }
      }),
      _c("span", [
        _vm._v(_vm._s(_vm.$t("tables.paginatorMessage", _vm.dataSource)))
      ]),
      _c("span", {
        staticClass: "glicon-next-large",
        class: { disabled: _vm.isLastPage },
        on: {
          click: function($event) {
            return _vm.next()
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }